export const DOCUMENTS_LIST_PAGE_SIZE = 21;

/**
 * Request body for POST /Documents. Kept free of axios so the shape is unit-testable.
 *
 * The two id fields select DIFFERENT backend paths (DocumentServices.GetAllDocumentsListByFilter):
 *  - `entity_id` (set)  -> GetAllVQAReportsByEntityId: the assessment's Draft / Final / Observation /
 *                          CAPA reports, with document_sub_type. Used by the Reports panels.
 *  - `vqa_id`           -> Document Library list filtered to that VQA's published library card.
 * Bug 14669: collapsing entityId into vqa_id made every Reports panel show only the published
 * "Report Anonymized" library card. Keep both fields distinct.
 */
export function buildDocumentsListPayload({
  currentPage,
  searchQuery,
  docType,
  provider,
  status,
  services,
  vqaId = null,
  entityId = null,
  service_names,
  page_size = DOCUMENTS_LIST_PAGE_SIZE,
  discoveryStatus = null,
  archiveStatusFilter = null,
  sortOptions = {},
  locationFilterParams = null,
  orgLibraryView = false,
}) {
  const { orderBy, sortDirection } = sortOptions || {};
  const payload = {
    current_page: currentPage,
    page_size,
    search_text: encodeURIComponent(searchQuery ?? ""),
    document_type: docType,
    provider_id_list: provider,
    document_status: status,
    rfi_id_list: service_names && service_names.length > 0 ? [] : services,
    rfi_name: service_names || [],
    vqa_id: vqaId ?? null,
    entity_id: entityId ?? null,
    ...(discoveryStatus !== null && { discovery_status: discoveryStatus }),
    ...(archiveStatusFilter && { archive_status_filter: archiveStatusFilter }),
    ...(orgLibraryView ? { org_library_view: true } : {}),
    ...(locationFilterParams?.country_list?.length && {
      country_list: locationFilterParams.country_list,
    }),
    ...(locationFilterParams?.state_list?.length && {
      state_list: locationFilterParams.state_list,
    }),
    ...(locationFilterParams?.city_list?.length && {
      city_list: locationFilterParams.city_list,
    }),
  };
  if (orderBy != null && orderBy !== "") {
    payload.sort_by = orderBy;
  }
  if (sortDirection === "asc" || sortDirection === "desc") {
    payload.sort_direction = sortDirection;
  }
  return payload;
}
